"use client";

import Footer from "@/components/layout/footer";
import Header from "@/components/layout/header";
import { type ReactNode, useEffect } from "react";

export default function HomeLayout({
  children,
}: Readonly<{
  children: ReactNode;
}>) {
  useEffect(() => {
    if (window.opener) {
      try {
        if (window.opener.origin) {
          // This was opened by the same origin, so we consider it safe.
          // console.log("safe");
        }
      } catch {
        // This window was opened via JS from an alternative origin.
        // For safety, we will the window.
        // console.log("unsafe");
        window.close();
      }
    }
  }, []);

  return (
    <>
      <Header />
      <main className="flex flex-col grow overflow-auto">{children}</main>
      <Footer />
    </>
  );
}
